import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
import { ACCOUNT_TYPE } from "./utils/constants";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AuditManagement from "./pages/admin/AuditManagement";
import AuditDetails from "./pages/admin/AuditDetails";
import IncidentReporting from "./pages/admin/IncidentReporting";
import UserManagement from "./pages/admin/UserManagement";
import Analytics from "./pages/admin/Analytics";
import Home from "./pages/Home";
import Login from "./components/Login/Login";
import Signup from "./components/Signup/Signup";
import OpenRoute from "./components/Auth/OpenRoute";
import PrivateRoute from "./components/Auth/PrivateRoute";
import Navbar from "./components/Navbar";
import TemplateManagement from "./pages/admin/TemplateManagement";
import Checklist from "./pages/admin/Checklist";
import { Dashboard } from "./pages/Dashboard";
import FeaturesPage from "./pages/FeaturesPage";
import Success from "./pages/success/success";
import Cancel from "./pages/cancel/cancel";
import MyProfile from "./components/Dashboard/MyProfile";
import Settings from "./components/Dashboard/Settings";
import UserDashboard from "./pages/user/UserDashboard";
import AuditDetailPage from "./pages/user/AuditDetail";
import SubmitReportPage from "./pages/user/SubmitReport";
import ClosurePage from "./pages/user/ClosurePage";
import TaskAssigned from "./pages/user/TaskAssigned";
import ViewAudit from "./pages/user/ViewAudit";
import AuditToggle from "./pages/user/AuditToggle"
import AreaManagementPage from "./pages/admin/AreaManagement";
import VerificationPage from "./pages/user/VerificationPage";
import Error from "./pages/Error"
import ForgotPassword from "./pages/ForgetPassword/ForegetPassword";
import UpdatePassword from "./pages/ForgetPassword/UpdatePassword";
import Scroll_To_Top_Button from "./utils/scroll_To_Top_Button"
import NotificationPage from "./pages/Notification";
import "./index.css";
// import LandingPage from "./pages/landingPage/App";

import SuperAdminDashboard from "./pages/superAdmin/SuperAdminDashboard";
import PlantManagement from "./pages/superAdmin/PlantManagement";

import { useDispatch } from "react-redux";
import { apiConnector } from "./services/apiconnector";
import { setUser } from "./redux/slices/profileSlice";
import { setToken, setLoading, clearAuth } from "./redux/slices/authSlice";
import { useEffect } from "react";
const API_BASE=process.env.REACT_APP_API_URL
function App() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profile)
  useEffect(() => {
    const checkAuth = async () => {
      dispatch(setLoading(true));
      try {
        const response = await apiConnector("GET", `${API_BASE}/auth/me`, null, {
          withCredentials: true,
        });
  
        if (response.success) {
          dispatch(setUser(response.user));
          dispatch(setToken("cookie")); 
        } else {
          dispatch(clearAuth());
        }
      } catch (err) {
        dispatch(clearAuth());
      } finally {
        dispatch(setLoading(false));
      }
    };
  
    checkAuth();
  }, [dispatch]);
  
  
  return (
    <>
      
      <div>
            <Navbar />
            <div className="">
              <Routes>
                <Route path="/" element={<Home />} />
               
              <Route path="/login" element={<OpenRoute><Login /></OpenRoute>} />
              <Route path="/signup" element={<OpenRoute><Signup /></OpenRoute>} />
              <Route path="/forgotPassword" element={<OpenRoute><ForgotPassword /></OpenRoute>}/>
              <Route path="update-password/:id"element={<OpenRoute><UpdatePassword /></OpenRoute>}/>
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/success" element={<Success />} />
              <Route path="/failure" element={<Cancel />} />
              <Route element={<PrivateRoute><Dashboard /></PrivateRoute>}>

              <Route path="dashboard/my-profile" element={<MyProfile />} />
              <Route path="dashboard/Settings" element={<Settings />} />
              <Route path="/auditdetails/checklist/:auditId" element={<ViewAudit />} />
              <Route path="/audit/verify" element={<VerificationPage />} />
              <Route path="/audit/:auditId" element={<AuditToggle/>}/>
              <Route path="audit/notification" element={<NotificationPage/>}/>

              {
                user?.accountType === ACCOUNT_TYPE.SUPER_ADMIN && (
                  <>
                  <Route path="/superadmin-dashboard" element={<SuperAdminDashboard />} />
                  <Route path="/plants" element={<PlantManagement />} />
                  </>
                )
              }
              {
        user?.accountType === ACCOUNT_TYPE.ADMIN && (
          <>

                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path="/admin/checklist/templates" element={<TemplateManagement />} />
                <Route path="/admin/checklist" element={<Checklist />} />
                <Route path="/admin/checklist/:templateId" element={<Checklist />} />
                <Route path="/admin/area" element={<AreaManagementPage />} />
                <Route path="/admin/audits" element={<AuditManagement />} />
                <Route path="/admin/audit-details/:id" element={<AuditDetails />} />
                <Route path="/incidents" element={<IncidentReporting />} />
                <Route path="/admin/add-users" element={<UserManagement />} />
                <Route path="/analytics" element={<Analytics />} />

              </>
        )}

                {
                user?.accountType === ACCOUNT_TYPE.EMPLOYEE && (
                <>
                
                <Route path="/user-dashboard" element={<UserDashboard />} />
                <Route path="/user/audit-assigned" element={<TaskAssigned />} />
                
                {/* <Route path="/user/audit/:auditId" element={<AuditDetailPage />} />
                <Route path="/user/audit/:auditId/create-report" element={<SubmitReportPage />} />
                <Route path="/audit/:auditId/closure" element={<ClosurePage />} /> */}
                

                </>
                )}
                </Route>
                <Route path="*" element={<Error />} />
              </Routes>
              <Scroll_To_Top_Button/>
            </div>
          </div>
       
    </>
  );
}

export default App;
